import React from "react";
import moment from "moment";

export default function EstDepartureDate({ date }) {
  const depart = moment(date);
  const isValid = depart.isValid();

  return <span>{isValid ? depart.format("DD MMMM YYYY") : "TBA"}</span>;
}
